import {
  Dropdown,
  FormField,
  listItemSelectBuilder
} from "@wix/design-system";
import React, { useMemo } from "react";
import { useBiNext } from "./../../bi-context-provider/bi-context-provider.js";
import { useSitePagesFetchContext } from "./../../site-pages/site-pages-fetch-context.js";
import { isDefined } from "./../../../wix-rich-content-common/index.js";
import { LINK_MODAL_ID } from "../constants.js";
import { LINK_TYPE } from "../data-hooks/data-hooks.js";
const translationTypes = {
  blogPost: "BlogPost",
  section: "Section",
  staticPage: "StaticPage",
  "web-address": "WebAddress"
};
const configToOption = (t, linkType) => listItemSelectBuilder({
  id: linkType,
  label: t(`LinkSettings_TypeSelect_Option_${translationTypes[linkType]}`),
  size: "small",
  title: t(`LinkSettings_TypeSelect_Option_${translationTypes[linkType]}`)
});
const defaultOptions = ["web-address", "section"];
const TypeSelect = ({
  autoFocus,
  dropDownPopoverProps,
  onSelect,
  showSitePages,
  t,
  type,
  enabledLinkTypes
}) => {
  const logBi = useBiNext({ pluginId: "link", modalId: LINK_MODAL_ID });
  const staticPagesState = useSitePagesFetchContext("staticPage", "").fetchState;
  const blogPostsState = useSitePagesFetchContext("blogPost", "").fetchState;
  const options = useMemo(() => {
    const availableLinkTypes = [
      ...defaultOptions,
      staticPagesState && staticPagesState.type === "ready" && staticPagesState.items?.length > 0 ? "staticPage" : void 0,
      blogPostsState && blogPostsState.type === "ready" && blogPostsState.items?.length > 0 ? "blogPost" : void 0
    ].filter(isDefined).filter((linkType) => enabledLinkTypes?.length ? enabledLinkTypes.includes(linkType) : true);
    return availableLinkTypes.map((linkType) => configToOption(t, linkType));
  }, [showSitePages, t, staticPagesState?.type, blogPostsState?.type, enabledLinkTypes]);
  const onOptionsShow = () => {
    logBi({ dataHook: LINK_TYPE });
  };
  const onSelectOption = (option) => {
    onSelect(option.id);
    logBi({ dataHook: LINK_TYPE, value: option.id });
  };
  return /* @__PURE__ */ React.createElement(FormField, { label: t("LinkSettings_TypeSelect_Label"), labelPlacement: "top" }, /* @__PURE__ */ React.createElement(
    Dropdown,
    {
      autoFocus,
      dataHook: LINK_TYPE,
      onOptionsShow,
      onSelect: onSelectOption,
      options,
      popoverProps: dropDownPopoverProps,
      selectedId: type,
      size: "small",
      valueParser: (option) => option.label
    }
  ));
};
export {
  TypeSelect
};
//# sourceMappingURL=type-select.js.map
